import currency from 'currency.js';
import isNil from 'lodash/isNil';

interface ICurrencySetting {
  emptyValue?: string;
  fromCents?: boolean;
}

export const getCurrencyString = (amount?: number | null, settings?: ICurrencySetting): string =>
  isNil(amount)
    ? (settings && settings.emptyValue) || ''
    : currency(amount!, { fromCents: settings && settings.fromCents }).format();
